/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default [
    {
        path: '/events',
        name: 'EventsList',
        component: () => import('@/views/Events/EventsList.vue'),
        meta: { permission: 'events.view' }
    },
    {
        path: '/events/new',
        name: 'EventCreate',
        component: () => import('@/views/Events/EventBuilder.vue'),
        meta: { permission: 'events.create' }
    },
    {
        path: '/events/:id',
        name: 'EventView',
        component: () => import('@/views/Events/EventView.vue'),
        meta: { permission: 'events.view' }
    },
    {
        path: '/events/:id/edit',
        name: 'EventEdit',
        component: () => import('@/views/Events/EventBuilder.vue'),
        meta: { permission: 'events.update' }
    }
]
